module.exports = __webpack_public_path__ + "assets/media/gandurina_o.194eee0a.jpg";